import React from 'react'
import CommonService from '../../services/CommonService'

const PrintPdfComponent = (props) => {
  const { issuanceDetail, drawDetails, contact } = props;

  return (
    <>
      <html lang="en">
        <head>
          <meta charset="UTF-8"></meta>
          <style>
            {
              "\
              div.repeat-header {\
                padding-top: 0.1in !important;\
                display: block !important;\
                text-align: center;\
                position: running(repeat-header) !important;\
              }\
              .report-header {\
                  text-align: center;\
                  padding: 5px;\
                  width: 100%;\
                  height: 40px;\
                  table-layout:fixed;\
                  border-collapse: collapse;\
            }\
              .report-heading-left {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  width: 20%;\
             }\
               .report-heading-left figure {\
                  margin: 0;\
                  padding: 0;\
            }\
              .report-heading-center {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: center;\
                  width: 60%;\
                  white-space: normal;\
                  overflow-wrap: break-word;\
              }\
              .report-heading-right {\
                  font-size: 12px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
                  width: 20%;\
                  white-space: nowrap;\
              }\
              .report-heading-center h1,.report-heading-center p, .report-heading-right p {\
                  margin: 0;\
                  padding: 0;\
              }\
              .report-heading-title {\
                  font-size: 18px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: left;\
                  min-width: 65%;\
              }\
              .report-heading-date {\
                  font-size: 10px;\
                  font-weight: 800;\
                  color: darkblue;\
                  text-align: right;\
              }\
              div.footer {\
                position: running(footer) !important;\
              }\
              #current-page-placeholder::before {\
                content: counter(page);\
              }\
              #total-pages-placeholder::before {\
                content: counter(pages);\
              }\
              @page {\
                  margin-top: 100px;\
                  @top-center {\
                      content: element(repeat-header) !important\
                  }\
              }\
              @page {\
                  @bottom-right {\
                      content: element(footer) !important;\
                      font-size: 10px;\
                  }\
              }\
              div.repeat-header table {\
                  page-break-inside: avoid;\
              }\
              div.repeat-header tr {\
                  page-break-inside: avoid;\
                  page-break-after: auto\
              }\
              div.repeat-header thead {\
                  display: table-header-group\
              }\
              div.repeat-header tfoot {\
                  display: table-footer-group\
              }\
              div.break-page {\
                  page-break-after: always;\
              }\
              .table a {\
                  color: black;\
                  text-decoration: underline;\
              }\
              .table .tableheader th, .table tbody th {\
                  color: #fff;\
                  background-color: darkblue;\
                  border-color: #454d55;\
                  vertical-align: middle;\
                  font-size: 1.0em;\
              }\
              .v-top {\
                  vertical-align: top !important;\
              }\
              tr {\
                  page-break-inside: avoid\
              }\
              h2.info-subsection, h2.sub-heading {\
                 font-size: 13px;\
                 font-weight: bold;\
                 text-align: left;\
                 vertical-align: bottom;\
              }\
              .invoice-box{\
                max-width: 800px;\
                margin: auto;\
                padding: 20px;\
                border: 1px solid #eee;\
                box-shadow: 0 0 10px rgba(0, 0, 0, .15);\
                font-size: 13px;\
                line-height: 18px;\
                font-family: Helvetica, Arial, sans-serif;\
                color: #555;\
              }\
              .invoice-box table {\
                width: 100%;\
                line-height: inherit;\
                text-align: left;\
              }\
              .invoice-box table td {\
                padding: 5px;\
                vertical-align: top;\
              }\
            .border-top {\
                  border-top: 2px solid #eee;\
              }\
              .invoice-box table tr.top table td.title {\
                  font-size: 13px;\
                  line-height: 22px;\
                  color: #333;\
              }\
              .invoice-box table tr.information table td {\
                  padding-bottom: 10px;\
              }\
              .invoice-box table tr.heading td {\
                  border-bottom: 1px solid #ddd;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.item td {\
                border-bottom: 1px solid #eee;\
              }\
              .invoice-box table tr.item.last td {\
                  border-bottom: none;\
              }\
              .invoice-box table tr.total {\
                  border-top: 2px solid #eee;\
                  font-weight: bold;\
              }\
              .invoice-box table tr.section-title td {\
                font-weight: bold;\
                font-size: 18px;\
                line-height: 18px;\
                color: #000;\
              }\
              .invoice-box .information table tr th {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                text-align: left;\
                font-weight: normal;\
             }\
              .invoice-box .information table tr td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                }\
              .information {\
                text-align: left;\
                padding-bottom: 20px;\
             }\
              .invoice-box .information .section-title {\
               font-weight: bold;\
               font-size: 18px;\
               line-height: 18px;\
               color: #000;\
               padding-bottom: 20px;\
             }\
              .info-subsection {\
                padding-bottom: 10px;\
             }\
              .invoice-box .information table.info-subsection caption {\
                text-align: left;\
             }\
              .fs-12 {\
                padding-bottom: 10px;\
             }\
              .invoice-box table tr.information table.data-table {\
                border: 1px solid #ddd;\
             }\
             .invoice-box .information table.data-table {\
                border: 1px solid #ddd;\
             }\
              .invoice-box information table.data-table tr.heading .th-left{\
                text-align: left;\
             }\
              .invoice-box .information table.data-table tr.heading .th-right {\
                text-align: right;\
             }\
              .invoice-box .information table.data-table th {\
                text-align: left;\
             }\
              .invoice-box .information table tr.heading th {\
                border-bottom: 1px solid #ddd;\
                font-weight: bold;\
                vertical-align: bottom;\
                text-align: left;\
             }\
              .invoice-box table tr.information th {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
                text-align: left;\
                font-weight: normal;\
             }\
              .invoice-box table tr.information td {\
                padding-bottom: 10px;\
                vertical-align: bottom;\
             }\
             @media only screen and (max-width: 600px) {\
              .invoice-box table tr.top table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              .invoice-box table tr.information table td {\
                  width: 100%;\
                  display: block;\
                  text-align: center;\
              }\
              }\
            "
            }
          </style>
        </head>
        <body className="pdf-box">
          <div className="invoice-box">
            <div><p className="fs-12"><i>Draw On Reserve/Default/Replenishment Information</i></p></div>
            <section className="information">
              <h1 className="section-title">Issuance</h1>
              <table>
                <tr><th>CDIAC #:</th><td align="right">{issuanceDetail.cdiacNumber}</td></tr>
                <tr><th>Issuer Name:</th><td align="right">{issuanceDetail.issuerName}</td></tr>
                <tr><th>Issue Name:</th><td align="right">{issuanceDetail.issueName}</td></tr>
                <tr><th>Project Name:</th><td align="right">{issuanceDetail.projectName}</td></tr>
                <tr><th>Actual Sale Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.actualSaleDate)}</td></tr>
                <tr><th>Settlement Date:</th><td align="right">{CommonService.dateFormatter(issuanceDetail.settlementDate)}</td></tr>
                <tr><th>Principal to be Sold:</th><td align="right">{CommonService.currencyFormatter(issuanceDetail.principalSaleAmt)}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Event Details</h1>
              <table>
                <tr><th>Submitted per:</th><td align="right">{drawDetails.drawCode !== null ? (drawDetails.drawCode === "MLR" ? "Section 53359.5(c) of the California Government Code Mello-Roos Community Facilities Districts Default or Draw on Reserve Reporting." : "Section 6599.1(c) of the California Government Code Marks-Roos Bond Pooling Act Participants Default or Draw on Reserve Reporting.") : ""} </td></tr>
                <tr><th>Event Type:</th><td align="right">{drawDetails.drawFlagDescription}</td></tr>
                <tr><th>Event Date:</th><td align="right">{CommonService.dateFormatter(drawDetails.drawDate)}</td></tr>
                <tr><th>Amount:</th><td align="right">{CommonService.currencyFormatter(drawDetails.drawAmt)}</td></tr>
              </table>
            </section>

            {/* Filing Contact */}
            <section className="information">
              <h1 className="section-title">Filing Contact</h1>
              <table>
                <tr><th>Filing Contact Name:</th><td align="right">{contact.contactFirstName} {contact.contactLastName}</td></tr>
                <tr><th>Agency/Organization Name:</th><td align="right">{contact.issuerName}</td></tr>
                <tr><th>Address:</th><td align="right">{contact.contactAddressLine1}</td></tr>
                <tr><th>City:</th><td align="right">{contact.contactCityName}</td></tr>
                <tr><th>State:</th><td align="right">{contact.contactStateCode}</td></tr>
                <tr><th>Zip Code:</th><td align="right">{contact.contactZipCode}</td></tr>
                <tr><th>Telephone:</th><td align="right">{contact.contactPhoneAreaCode && contact.contactPhoneAreaCode + "-"}{contact.contactPhoneNumber}</td></tr>
                <tr><th>Fax Number:</th><td align="right">{contact.contactFaxNumber}</td></tr>
                <tr><th>E-mail:</th><td align="right">{contact.contactEmailId}</td></tr>
              </table>
            </section>

            <section className="information">
              <h1 className="section-title">Comments</h1>
              <table>
                <tr><th>Issuer Comments:&nbsp;</th><td>{drawDetails.issuerComment}</td></tr>
                <tr><th>CDIAC Comments:&nbsp;</th><td>{drawDetails.cdiacComment}</td></tr>
              </table>
            </section>

            <section>
              <table>
                {drawDetails.statusFlag !== 'D' &&
                  <tr className="information">
                    <th>Submission Date:</th>
                    <td align="right">{CommonService.dateFormatter(drawDetails.filingDate)}</td>
                  </tr>
                }
                {drawDetails.statusFlag === 'R' &&
                  <tr className="information">
                    <th>Review Date:</th>
                    <td align="right">{CommonService.dateFormatter(drawDetails.lastUpdateDatetime)}</td>
                  </tr>
                }
              </table>
            </section>
          </div>
        </body>
      </html>
    </>
  );
  //}
}

export default PrintPdfComponent;